import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconInfoFilled, IconClose, IconConvert, IconTick } from 'svgIcons/MotionPortalIcons';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import colors from 'theme/_colors.scss';

import './styles.scss';

const ConvertToLocationBanner = ({
    onConvertClick,
    onKeepClick,
    onClose,
    isVisible
}) => {
    const { t: translate } = useTranslation();

    if (!isVisible) {
        return null;
    }

    return (
        <div className='convert-to-location-banner'>
            <div className='convert-to-location-banner__header'>
                <div className='convert-to-location-banner__icon'>
                    <IconInfoFilled width={16} height={16} color={colors.blueRibbon} />
                </div>
                <div className='convert-to-location-banner__title'>
                    {translate('ABB.Powertrain.Frontend.convertToLocationBannerTitle')}
                </div>
                {onClose &&
                    <button
                        className='convert-to-location-banner__close'
                        onClick={onClose}
                        type='button'
                        aria-label={translate('ABB.Powertrain.Frontend.closeLabel') || 'Close'}
                    >
                        <IconClose width={16} height={16} />
                    </button>
                }
            </div>
            <div className='convert-to-location-banner__content'>
                <div className='convert-to-location-banner__description'>
                    {translate('ABB.Powertrain.Frontend.convertToLocationBannerDescription')}
                </div>
                <div className='convert-to-location-banner__actions'>
                    <GeneralButton
                        type='primary'
                        text={translate('ABB.Powertrain.Frontend.convertToLocationGroupBtn')}
                        onClick={onConvertClick}
                        icon={<IconConvert width={16} height={16} color={colors.white} />}
                    />
                    <GeneralButton
                        type='discreet'
                        text={translate('ABB.Powertrain.Frontend.keepAsPowertrainBtn')}
                        onClick={onKeepClick}
                        icon={<IconTick width={14} height={12} color={colors.mineShaft} />}
                    />
                </div>
            </div>
        </div>
    );
};

ConvertToLocationBanner.propTypes = {
    onConvertClick: PropTypes.func.isRequired,
    onKeepClick: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    isVisible: PropTypes.bool
};

ConvertToLocationBanner.defaultProps = {
    isVisible: true
};

export default ConvertToLocationBanner;
